import {
  caStateCodeToNameMap,
  countryCode,
  dictionary,
  mxStateCodeToNameMap,
  usStateCodeToNameMap
} from 'commons/types/dictionaries'

export const determineStateData = (country: string | undefined) => {
  switch (country) {
    case undefined:
    case '':
      return dictionary.usStates
    case 'US':
      return dictionary.usStates
    case 'AS':
      return dictionary.asStates
    case 'GU':
      return dictionary.guStates
    case 'MH':
      return dictionary.mhStates
    case 'FM':
      return dictionary.fmStates
    case 'CA':
      return dictionary.caStates
    case 'MP':
      return dictionary.mpStates
    case 'PW':
      return dictionary.pwStates
    case 'PR':
      return dictionary.prStates
    case 'VI':
      return dictionary.viStates
    case 'MX':
      return dictionary.mxStates
  }
  return []
}

export const isStateRequiredCountry = (country: string | undefined) => {
  if (country && ['US', 'AS', 'GU', 'MH', 'FM', 'CA', 'MP', 'PW', 'PR', 'VI', 'MX'].indexOf(country) !== -1) {
    return true
  }
  return false
}

export const getState = ({ country = countryCode.US, state }: { country?: string; state: string }) => {
  if (country === countryCode.US) {
    return usStateCodeToNameMap[state]
  }
  if (country === countryCode.CA) {
    return caStateCodeToNameMap[state]
  }
  if (country === countryCode.MX) {
    return mxStateCodeToNameMap[state]
  }
}
